import { render, staticRenderFns } from "./card-accordions.vue?vue&type=template&id=1ddd49de&scoped=true&"
import script from "./card-accordions.vue?vue&type=script&lang=js&"
export * from "./card-accordions.vue?vue&type=script&lang=js&"
import style0 from "./card-accordions.vue?vue&type=style&index=0&id=1ddd49de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd49de",
  null
  
)

export default component.exports